<template>
  <div class="mb-4 w-full flex flex-col items-start">
    <label
        v-if="label"
        :for="name"
        class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2"
    >
        {{ label }} <span v-if="required" class="text-red-500">*</span>
    </label>
    <textarea
        :id="name"
        :name="name"
        v-model="inputValue"
        class="appearance-none block w-full h-32 bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white resize-none"
        :class="{ 'border-red-500': error }"
    ></textarea>
    <p v-if="error" class="text-red-500 text-xs italic">{{ errorMessage }}</p>
  </div>
</template>

<script>
export default {
  name: "Textarea",
  props: {
    modelValue: String,
    label: String,
    name: String,
    required: {
        type: Boolean,
        default: false,
    },
    error: Boolean,
    errorMessage: {
        type: String,
        default: "Este campo es requerido",
    },
  },
  computed: {
    inputValue: {
        get() {
            return this.modelValue;
        },
        set(value) {
            this.$emit("update:modelValue", value);
        },
    },
  },
};
</script>
